/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @getify/proper-ternary/nested */
import { Drawer, Tab, Tabs } from '@material-ui/core';
import styled from 'styled-components/macro';
import { useEffect, useState } from 'react';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { KeyboardDatePicker } from '@material-ui/pickers';
import {
  QuotePayment,
  QuoteSummeryUpdate,
  RepairCase,
} from 'app/core/api/repairer/api-repairer.types';
import {
  useEffectOnChanges,
  useUrlParams,
  useWatchAsRef,
} from 'app/tools/hooks/misc-hooks';
import {
  useQuotePayment,
  useQuoteSummery,
  useUpdateQuoteSummery,
  useWarrantyClaimPayment,
} from 'app/core/api/repairer/api-repairer';
import { useSetPageTitle } from 'app/shared/context-hooks/use-titlebar.hook';
import { useShowInfo } from 'app/shared/context-hooks/use-show-info.hook';
import styledMixins from 'app/styles/styledMixins';
import QuoteAddress from './quote-address';

const QuoteTabs = styled(Tabs)`
  ${styledMixins.softShadow}
`;

type Props = {
  isWarrantyDrawerOpen: boolean;
  SetIsWarrantyDrawerOpen: (isVisible: boolean) => unknown;
  setIsQuoteDetailOpen: (isVisible: boolean) => unknown;
  repairCase: RepairCase | undefined;
};
export default function WarrantyDrawer({
  isWarrantyDrawerOpen,
  SetIsWarrantyDrawerOpen,
  setIsQuoteDetailOpen,
  repairCase,
}: Props): JSX.Element {
  const { id } = useUrlParams(['id']);
  const {
    resource: quoteSummery,
    loading,
    loadingMissing,
    request,
  } = useQuoteSummery(id);
  const { request$: updateQuoteSummery$ } = useUpdateQuoteSummery();
  const {
    request$: updateQuotePayment$,
    sending: updateQuotePayment,
    error: apiError,
  } = useWarrantyClaimPayment();
  const loadingRef = useWatchAsRef(loading);

  const titleMsg = loadingMissing ? 'Loading...' : `Task Info`;
  useEffect(() => {
    if (!loadingRef.current) request();
  }, [loadingRef, request]);
  useSetPageTitle(titleMsg);
  const [isShowPaymentOption, setIsShowPaymentOption] =
    useState<boolean>(false);
  const [selectedDate, setSelectedDate] = useState<string>();
  const [deliveryLocation, setDeliveryLocation] = useState<number>();
  const [paymentMethodId, setPaymentMethodId] = useState<string>();
  const { showSnack } = useShowInfo();

  const DatePickerContainer = styled.div`
    margin: 0 auto;
  `;
  const onChange = (
    date: MaterialUiPickersDate,
    value?: string | null | undefined
  ) => {
    setSelectedDate(`${value ?? ' 00:00'}`);
  };
  useEffectOnChanges(() => {
    if (isShowPaymentOption) {
      const amount = quoteSummery?.diagnosisQuote
        ? quoteSummery.diagnosisQuote
            .map(item => item.quotationAmount.amount)
            .reduce((prev, curr) => prev + curr, 0)
        : 0;

      const amount1 = quoteSummery?.repairQuote
        ? quoteSummery?.repairQuote
            .map(item => item.quotationAmount.amount)
            .reduce((prev, curr) => prev + curr, 0)
        : 0;
      const summery: QuoteSummeryUpdate = {
        id: repairCase?.id ?? 0,
        deliveryLocation: deliveryLocation ?? 0,
        pickUpDate: `${selectedDate ?? ''} 10:00`,
        dropOffDate: `${selectedDate ?? ''} 10:00`,
      };
      updateQuoteSummery$(summery).subscribe(() => {
        const payment: QuotePayment = {
          repairCaseId: repairCase?.id ?? 0,
          amount: (amount + amount1)?.toString() ?? '',
          currency: 'GBP',
          paymentMethodId: paymentMethodId ?? '',
        };
        // eslint-disable-next-line rxjs/no-nested-subscribe
        updateQuotePayment$(payment).subscribe(() => {
          SetIsWarrantyDrawerOpen(false);
          setIsQuoteDetailOpen(true);
        });
      });
    }
  }, [
    SetIsWarrantyDrawerOpen,
    deliveryLocation,
    isShowPaymentOption,
    paymentMethodId,
    quoteSummery?.diagnosisQuote,
    quoteSummery?.repairQuote,
    repairCase?.id,
    selectedDate,
    setIsQuoteDetailOpen,
    updateQuotePayment$,
    updateQuoteSummery$,
  ]);

  useEffectOnChanges(() => {
    if (apiError && apiError.detail) {
      showSnack({ message: apiError.detail ?? '' });
    }
  }, [apiError, showSnack]);
  return (
    <>
      <Drawer
        anchor="bottom"
        open={isWarrantyDrawerOpen}
        onClose={() => SetIsWarrantyDrawerOpen(false)}
      >
        <QuoteTabs
          value={1}
          variant="fullWidth"
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab value={1} label="Collection Date" />
        </QuoteTabs>
        {quoteSummery ? (
          <div style={{ display: 'block', margin: '20px' }}>
            <>
              <span>Please select a day </span>
              <DatePickerContainer>
                <KeyboardDatePicker
                  variant="static"
                  format="yyyy-MM-dd"
                  margin="normal"
                  name="startDate"
                  value={selectedDate}
                  onChange={onChange}
                  disablePast
                  disableToolbar
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </DatePickerContainer>
            </>

            <div>
              {selectedDate && (
                <QuoteAddress
                  setIsShowPaymentOption={setIsShowPaymentOption}
                  setDeliveryLocation={setDeliveryLocation}
                  deliveryLocation={deliveryLocation ?? 0}
                />
              )}
            </div>
          </div>
        ) : (
          <></>
        )}
      </Drawer>
    </>
  );
}
